export class Colors {
	primary = "#1F1F1F";
	primaryBackground  = "#1F1F1FA0";
	accent = "#CDAD70";
	accentBackground = "#CDAD70A0";
	secondary = "#F54245";
	secondaryBackground = "#F54245"
	child = "#3461EB";
	childBackground="#3461EB";

}



// WEBPACK FOOTER //
// ./src/app/models/Utility/colors.ts